'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventEmitter = require('./eventEmitter');

var _eventEmitter2 = _interopRequireDefault(_eventEmitter);

var _history = require('./history');

var _history2 = _interopRequireDefault(_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Backbone.Router
var _class = function (_EventEmitter) {
    _inherits(_class, _EventEmitter);

    // Routers map faux-URLs to actions, and fire events when routes are
    // matched. Creating a new one sets its `routes` hash, if not set statically.


    // Cached regular expressions for matching named param parts and splatted
    // parts of route strings.
    function _class() {
        var _ret;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

        _this.optionalParam = /\((.*?)\)/g;
        _this.namedParam = /(\(\?)?:\w+/g;
        _this.splatParam = /\*\w+/g;
        _this.escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g;

        if (options.routes) _this.routes = options.routes;
        _this.history = new _history2.default();
        _this._bindRoutes();

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //


    _createClass(_class, [{
        key: 'route',
        value: function route(_route, name, callback) {
            var _this2 = this;

            if (!(_route instanceof RegExp)) _route = this._routeToRegExp(_route);

            if (typeof name === 'function') {
                callback = name;
                name = '';
            }

            if (!callback) callback = this[name];

            this.history.route(_route, function (fragment) {
                var args = _this2._extractParameters(_route, fragment);
                callback && callback.apply(_this2, args);
                _this2.trigger.apply(_this2, ['route:' + name].concat(args));
                _this2.trigger('route', name, args);
                _this2.history.trigger('route', _this2, name, args);
            });

            return this;
        }
    }, {
        key: 'start',
        value: function start() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.history.start(options);
            return this;
        }

        // Simple proxy to `History` to save a fragment into the history.

    }, {
        key: 'navigate',
        value: function navigate(fragment, options) {
            this.history.navigate(fragment, options);
            return this;
        }

        // Bind all defined routes to `History`. We have to reverse the
        // order of the routes here to support behavior where the most general
        // routes can be defined at the bottom of the route map.

    }, {
        key: '_bindRoutes',
        value: function _bindRoutes() {
            if (!this.routes) return;

            if (this.routes && typeof this.routes === 'function') {
                this.routes = this.routes.call(this);
            }

            var route,
                routes = Object.keys(this.routes);
            while ((route = routes.pop()) != null) {
                this.route(route, this.routes[route]);
            }
        }

        // Convert a route string into a regular expression, suitable for matching
        // against the current location hash.

    }, {
        key: '_routeToRegExp',
        value: function _routeToRegExp(route) {
            route = route.replace(this.escapeRegExp, '\\$&').replace(this.optionalParam, '(?:$1)?').replace(this.namedParam, function (match, optional) {
                return optional ? match : '([^\/]+)';
            }).replace(this.splatParam, '(.*?)');
            return new RegExp('^' + route + '$');
        }

        // Given a route, and a URL fragment that it matches, return the array of
        // extracted decoded parameters. Empty or unmatched parameters will be
        // treated as `null` to normalize cross-browser behavior.

    }, {
        key: '_extractParameters',
        value: function _extractParameters(route, fragment) {
            var params = route.exec(fragment).slice(1);
            return params.map(function (param) {
                return param ? decodeURIComponent(param) : null;
            });
        }
    }]);

    return _class;
}(_eventEmitter2.default);

exports.default = _class;